import { render, staticRenderFns } from "./FeaturedNodeDefResultsContainer.vue?vue&type=template&id=4fccaa2d&scoped=true"
import script from "./FeaturedNodeDefResultsContainer.vue?vue&type=script&lang=ts"
export * from "./FeaturedNodeDefResultsContainer.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedNodeDefResultsContainer.vue?vue&type=style&index=0&id=4fccaa2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fccaa2d",
  null
  
)

export default component.exports